import type { AttachmentItem } from '../types';

interface PublisherPreviewProps {
  badge: string;
  accent?: string;
  title: string;
  summary: string;
  rows?: Array<[string, string]>;
  sourceUrl?: string;
  tags: string[];
  attachments?: AttachmentItem[];
  confirmLabel: string;
  busy?: boolean;
  error?: string;
  onEdit: () => void;
  onConfirm: () => void;
}

/** Public card preview used after each independent Publisher form. */
export const PublisherPreview = ({
  badge,
  accent = '#41d2ff',
  title,
  summary,
  rows = [],
  sourceUrl,
  tags,
  attachments = [],
  confirmLabel,
  busy,
  error,
  onEdit,
  onConfirm,
}: PublisherPreviewProps) => (
  <section className="rg-panel rg-publisher-preview">
    <span className="rg-chip" style={{ borderColor: accent, color: accent }}>
      {badge}
    </span>
    <h3 style={{ margin: '10px 0 6px' }}>{title}</h3>
    <p style={{ margin: 0, color: '#9bb7c6' }}>{summary || 'Без дополнительного описания'}</p>
    {rows.length ? (
      <div className="rg-summary" style={{ marginTop: 14 }}>
        {rows.slice(0, 6).map(([label, value]) => (
          <div key={label} className="rg-summary-row">
            <span>{label}</span>
            <strong>{value}</strong>
          </div>
        ))}
      </div>
    ) : null}
    {sourceUrl ? (
      <p style={{ marginTop: 12, color: '#c5d7e2' }}>
        <b>Официальный источник:</b> {sourceUrl}
      </p>
    ) : null}
    {tags.length ? (
      <div className="rg-chip-row" style={{ marginTop: 12 }}>
        {tags.map((tag) => (
          <span key={tag} className="rg-chip">
            #{tag.replace(/^#/, '')}
          </span>
        ))}
      </div>
    ) : null}
    {attachments.length ? (
      <p style={{ marginTop: 12, color: '#86a6b6' }}>
        Вложения: {attachments.map((file) => file.name).join(', ')}
      </p>
    ) : null}
    {error ? <p role="alert" className="rg-publisher-error">{error}</p> : null}
    <div className="rg-etalon-actions">
      <button type="button" className="rg-btn" disabled={busy} onClick={onEdit}>
        ← Вернуться к редактированию
      </button>
      <span style={{ flex: 1 }} />
      <button type="button" className="rg-btn primary" disabled={busy} onClick={onConfirm}>
        {busy ? 'Отправка…' : confirmLabel}
      </button>
    </div>
  </section>
);
